import React, { Component } from 'react';
import { Modal, Row, Col, Button } from 'reactstrap';
import Dropzone from 'react-dropzone';
import Toast from '../common/custom-controls/Toast';
import { lotteryService } from '../../services/lottery-service';
import { errorCode } from './../../utils/error-code';
import SubmitButton from '../common/custom-controls/SubmitButton';

class DragAndDrop extends Component {

    INITIAL_STATE = {
        showModal: false,
        toast: {
            type: '',
            message: ''
        },
        submitted: false, // Moved here to ensure it resets cleanly
        step: 'upload' 
    }

    constructor(props) {
        super(props);

        this.state = {
            ...this.INITIAL_STATE,
            files: [],
            showModal: props.showModal,
            data: props.dragData,
        };
    }

    // Explicitly reset local state values when closing
    handleClose = (msg) => {
        this.setState({
            ...this.INITIAL_STATE,
            files: []
        }, () => {
            this.props.onClose(msg);
        });
    }

    // Review step transition
    handleSubmit = () => {
        if (!this.state.files.length) {
            this.setState({
                submitted: false,
                toast: {
                    type: 'warning',
                    message: 'Please Select file'
                }
            });
            return;
        }

        // Ensure submitted is false when entering review screen
        this.setState({ 
            step: 'review',
            submitted: false 
        });
    }

    // Actual upload execution
    handleConfirmUpload = () => {
        const { data } = this.state;

        this.setState({ submitted: true });

        const fileData = new FormData();
        const file = this.state.files[0];

        fileData.append('file', file);
        fileData.append('drawId', data.id);
        fileData.append('drawNumber', data.drawNumber);
        fileData.append('lotteryId', data.lotteryId);

        lotteryService.uploadDrawFiles(fileData)
            .then((results) => {
                if (results.status === 200) {
                    this.setState({
                        ...this.INITIAL_STATE,
                        files: []
                    });

                    this.handleClose({
                        message: 'Data is being uploaded in background, you will get an email once completed.'
                    });
                } else {
                    this.setState({
                        submitted: false,
                        toast: {
                            type: 'warning',
                            message: results.data.description
                        }
                    });
                }
            })
            .catch((error) => {
                try {
                    error = JSON.parse(JSON.stringify(error));
                    let code = error.message.substring(error.message.length - 3);
                    this.setState({
                        submitted: false,
                        toast: {
                            type: 'warning',
                            message: errorCode[code] || 'An error occurred'
                        }
                    });
                } catch (e) {
                    this.setState({
                        submitted: false,
                        toast: {
                            type: 'warning',
                            message: 'Upload failed'
                        }
                    });
                }
            });
    }

    onDrop = (files) => {
        if (files.length > 1) {
            this.setState({
                toast: {
                    type: 'warning',
                    message: 'Please Select only one file'
                }
            });
        } else {
            this.setState({ 
                files,
                toast: { type: '', message: '' } // Clear any existing warnings on a valid drop
            });
        }
    }

    // Safely clear submission locks when going back
    handleBack = () => {
        this.setState({ 
            step: 'upload',
            submitted: false 
        });
    }

    renderUploadStep() {
        const files = this.state.files.map(file => (
            <li key={file.name}>
                {file.name} - {file.size} bytes
            </li>
        ));

        const dragText = (
            <div>
                <h5>Drag & Drop Tickets file to upload</h5>
                <i className="fa fa-upload" style={{ fontSize: "36px" }}></i>
            </div>
        );

        return (
            <>
                <h4>Upload Tickets</h4>
                <br />

                <Dropzone onDrop={this.onDrop}>
                    {({ getRootProps, getInputProps }) => (
                        <div
                            {...getRootProps()}
                            style={{
                                border: '3px dashed #0275d8',
                                padding: '20px',
                                textAlign: 'center',
                                color: '#0275d8',
                                cursor: 'pointer'
                            }}
                        >
                            <input {...getInputProps()} accept=".dbf" />
                            {this.state.files.length ? files : dragText}
                        </div>
                    )}
                </Dropzone>

                <br />

                <Row>
                    <Col>
                        <Button color="secondary" onClick={() => this.handleClose()}>
                            Cancel
                        </Button>
                    </Col>

                    <Col className="text-right">
                        <SubmitButton
                            shouldDisable={this.state.submitted}
                            submitted={this.state.submitted}
                            color="primary"
                            onSubmit={this.handleSubmit}
                        >
                            Next
                        </SubmitButton>
                    </Col>
                </Row>
            </>
        );
    }

    renderReviewStep() {
        const { files } = this.state;

        return (
            <>
                <div
                    style={{
                        background: '#f2b0b0ff',
                        border: '1px solid #fd2e2eff',
                        padding: '14px',
                        borderRadius: '8px',
                        marginBottom: '16px',
                        color: '#780404ff'
                    }}
                >
                    <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 700 }}>
                        ⚠️ Final Confirmation Required
                    </h3>

                    <p style={{ margin: '6px 0 0', fontSize: '15px', color: '#9e0404ff' }}>
                        You are about to upload Ticket file to the system.
                        Please verify carefully before continuing.
                    </p>
                </div>

                <div
                    style={{
                        background: '#ffffffff',
                        border: '1px solid #333',
                        borderRadius: '10px',
                        padding: '14px',
                        marginBottom: '16px'
                    }}
                >
                    <h4 style={{ color: '#000000ff', marginBottom: '10px', fontSize: '16px', fontWeight: 600 }}>
                        Review File
                    </h4>

                    {files && files.length > 0 ? (
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            {files.map(file => (
                                <li
                                    key={file.name}
                                    style={{
                                        padding: '10px',
                                        background: '#dddadaff',
                                        marginBottom: '8px',
                                        borderRadius: '6px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        fontSize: '15px',
                                        color: '#fff'
                                    }}
                                Vice>
                                    <span style={{ fontWeight: 600 ,  color: '#000000ff'}}>
                                        {file.name}
                                    </span>

                                    <span style={{ color: '#000000ff' }}>
                                        {(file.size / 1024).toFixed(2)} KB
                                    </span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p style={{ color: '#888' }}>
                            No file selected
                        </p>
                    )}
                </div>

                <div
                    style={{
                        background: '#f3d0d0ff',
                        border: '1px solid #ff3b3b',
                        padding: '12px',
                        borderRadius: '8px',
                        marginBottom: '20px'
                    }}
                >
                    <p style={{ margin: 0, color: '#650404ff', fontSize: '14px', fontWeight: 600 }}>
                        ⚠️ This action may affect live data. It cannot be easily undone.
                    </p>
                </div>

                <Row>
                    <Col>
                        <Button
                            color="secondary"
                            style={{ fontSize: '14px', padding: '10px 16px' }}
                            onClick={this.handleBack}
                        >
                            Back
                        </Button>
                    </Col>

                    <Col className="text-right">
                        <Button
                            color="danger"
                            style={{
                                fontSize: '15px',
                                padding: '10px 18px',
                                fontWeight: 700
                            }}
                            onClick={this.handleConfirmUpload}
                            disabled={this.state.submitted}
                        >
                            Confirm Upload
                        </Button>
                    </Col>
                </Row>
            </>
        );
    }

    render() {
        const { toast, showModal, step } = this.state;

        return (
            <Modal isOpen={showModal} toggle={() => this.handleClose()}>
                <Toast
                    handleOnClose={() => this.setState({ toast: { type: '', message: '' } })}
                    isOpen={!!toast.message}
                    type={toast.type}
                    message={toast.message}
                />

                <div style={{ backgroundColor: '#eee', padding: 20 }}>
                    {step === 'upload'
                        ? this.renderUploadStep()
                        : this.renderReviewStep()}
                </div>
            </Modal>
        );
    }
}

export default DragAndDrop;